export const getDirection = (lang: string): 'rtl' | 'ltr' => {
    return ['ckb', 'ar'].includes(lang) ? 'rtl' : 'ltr';
};
